import { motion } from "framer-motion";
import { Lock, BookOpen, Scale, Smartphone } from "lucide-react";
import { IMAGES } from "../../lib/site";
import { Eyebrow, Reveal } from "./Motion";

const REASONS = [
  { icon: Lock, title: "Private & judgement-free", text: "Every conversation stays confidential. Bring any question — nothing is too small or too personal." },
  { icon: BookOpen, title: "Rooted in tradition", text: "Guidance grounded in classical Vedic astrology, palmistry and time-honoured healing practices." },
  { icon: Scale, title: "Honest, practical advice", text: "No fear-based predictions. You leave with perspective and clear next steps you can act on." },
  { icon: Smartphone, title: "In person or remote", text: "Visit us in Calgary, or connect by phone or WhatsApp from wherever you are." },
];

export const WhyChooseUs = () => (
  <section data-testid="why-choose-us-section" className="relative overflow-hidden bg-[#0B1120]/60 px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
    <div className="stars absolute inset-0 opacity-40" />
    <div className="relative mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow>Why Choose Us</Eyebrow>
          <h2 className="font-display mt-5 text-4xl leading-[1.02] text-white sm:text-5xl lg:text-6xl">
            Guidance you can <span className="italic gold-text">trust</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-300">
            Choosing a spiritual advisor is personal. Here is what you can expect when you sit down with us.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="mt-10">
          <div className="clip-notch relative aspect-[5/4] overflow-hidden">
            <img src={IMAGES.crystal} alt="Healing crystals arranged for a spiritual session" loading="lazy" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#2a1050]/50 to-transparent mix-blend-multiply" />
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        {REASONS.map((r, i) => {
          const Icon = r.icon;
          return (
            <motion.div key={r.title} data-testid={`why-item-${i}`}
              initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              className="group grid grid-cols-[auto_1fr] gap-6 border-b border-[#D4AF37]/15 py-9 first:pt-0 sm:gap-10">
              <span className="font-display text-5xl italic text-[#D4AF37]/50 transition-colors duration-500 group-hover:text-[#D4AF37] sm:text-6xl">0{i + 1}</span>
              <div>
                <div className="flex items-center gap-3">
                  <Icon className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.4} />
                  <h3 className="font-display text-2xl text-white sm:text-3xl">{r.title}</h3>
                </div>
                <p className="mt-3 text-[15px] leading-relaxed text-slate-300">{r.text}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
